import { render, staticRenderFns } from "./SendFileToAdmin.vue?vue&type=template&id=0d0528c9&scoped=true&"
import script from "./SendFileToAdmin.vue?vue&type=script&lang=js&"
export * from "./SendFileToAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SendFileToAdmin.vue?vue&type=style&index=0&id=0d0528c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0528c9",
  null
  
)

export default component.exports